export enum EModelName {
  USER = 'User',
  DeletedUser = 'Deleted-User',
  TOKEN = 'Token',
  AIRecurringTask = 'AI-Recurring-Task',
  AIEventBasedAction = 'AI-Event-Based-Action',
  AssistantThread = 'Assistant-Thread',
  AssistantUserFeedback = 'Assistant-User-Feedback',
  UserScraping = 'User-Scraping',
  UserInteraction = 'User-Interaction',
  Contact = 'Contact',
  MeetingRecording = 'Meeting-recording',
  MeetingLogs = 'Meeting-log',
  MeetingBotLogs = 'Meeting-Bot-Logs',
  AssistantActions = 'Assistant-Actions',
  Podcast = 'Podcast',
  ActionItems = 'Action-Items',
  MeetingTranscript = 'Meeting-Transcript',
  Transaction = 'Transaction',
  MultiplayerCoin = 'Multiplayer-coin',
  Activity = 'Activity',
  SubscriptionPlan = 'Subscription-Plan',
  InboxManagementSettings = 'Inbox-Management-Settings',
  LLMLogs = 'LLM-Logs',

  EventQueue = 'Event-Queue',
  UserAlert = 'User-Alert',
  TokenUsage = 'Token-Usage',
  UserCost = 'User-Cost',
  CompanyInfo = 'CompanyInfo',
  UserInfo = 'UserInfo',
  GmailTemporaryStats = 'Gmail-Temporary-Stats',
  GmailCreatedLabels = 'Gmail-created-labels',
  EmailStats = 'Email-Stats',

  GmailSnapshot = 'Gmail-Snapshot',
}
